export const EmailNotificationUserType = {
    Internal: 1,
    External: 2,
    Internal_CertificationWorkflow: 3,
    External_3dsUser: 4,
    Internal_VssEmailGroup: 5,
}

export const EmailNotificationInternalUserTypes = new Set([
    EmailNotificationUserType.Internal,
    EmailNotificationUserType.Internal_CertificationWorkflow,
    EmailNotificationUserType.Internal_VssEmailGroup,
]);

export const EmailNotificationService = {
    Daf: 1,
    Vsts: 2,
    VstsExpirationReminder: 3,
    ComplianceLetter: 4,
}

export const EmailNotificationEvent = {
    DafAcquirer: 3,
    CertificationPackageStateUpdateInternal: 6,
    DeferredPackageRequestReviewInternal: 7,
    CertificationPackageStateUpdateExternal: 8,
    BaseVstsExpirationReminderExternal: 9,
    VstsBaseSubscriptionExpirationReminderInternal:10,
    VstsExtensionExpirationReminderExternal: 11,
    VstsExtensionExpirationReminderInternal: 12,
    ComplianceLetterExpirationReminderExternal: 13,
    ComplianceLetterExpirationReminderInternal: 14
}

export const EmailNotificationEventType = {
    Recurring: 1,
    Alert: 2,
    Reminder: 3,
    Exported: 4
}

export const EmailNotificationSelectedUserNote = {
    DafAcquirer: `List contains Visa Secure Services acquirer users with the VSS role of "3DS User - External" who have been entitled with "3DS DAF Acquirer VMID Flag".`,
    ExternalUser: `List contains Visa Secure Services users with the VSS role of "3DS User - External".`,
}

export const EmailNotificationUnselectedUserNote = {
    DafAcquirer: `List contains Visa Secure Services users with the VSS role of "Super Admin", "Tools & Lib Admin" and "3DS User - Visa Staff".`,
    Vsts: `Internal VSS email group. Members include users with the following VSS roles: "Super Admin", "Tools & Lib Admin" with 'Certification Workflow' entitlement".`,
    VstsExpirationReminder: `List contains Visa Secure Services users with the VSS role of "Super Admin", "Tools & Lib Admin" and "3DS User - Visa Staff" with extended access.`,
    ComplianceLetter: `List contains Visa Secure Services users with the VSS role of "Super Admin", "Tools & Lib Admin" and "3DS User - Visa Staff" with extended access.`
}

export const SelectiveEmailNotifications = [
    EmailNotificationEvent.CertificationPackageStateUpdateInternal, 
    EmailNotificationEvent.DeferredPackageRequestReviewInternal,
    EmailNotificationEvent.VstsBaseSubscriptionExpirationReminderInternal,
    EmailNotificationEvent.VstsExtensionExpirationReminderInternal,
    EmailNotificationEvent.ComplianceLetterExpirationReminderInternal
];

